import { TileRoleRoute } from '@/types'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { Roles } from '@/auth/azure/Roles'
import { UserRoute } from '@/routes/admin/users/user/User.route'
import { UsersGridRoute } from '@/routes/admin/users/grid/UsersGrid.route'
import { AutoRoute } from '@/routes/admin/users/auto/Auto.route'
// import { BadgeRoute } from '@/routes/admin/users/badge/Badge.route'
import { AgentRoute } from '@/routes/admin/users/agent/Agent.route'
import { CostCenterRoute } from '@/routes/admin/users/costcenter/CostCenter.route'
import { PiattaformaAttivitaLavorativaRoute } from '@/routes/admin/users/PiattaformaAttivitaLavorativa.route'
import { RepartoRoute } from '@/routes/admin/users/Reparto.route'
import { CostCenterRationaleRoute } from '@/routes/admin/users/costcenterrationale/CostCenterRationale.route'

export const UsersRoute: TileRoleRoute = {
  path: 'users',
  text: 'Utenti',
  mainMenuRoute: false,
  faIcon: faUser,
  handle: {
    crumb: () => ({
      label: 'Utenti',
      icon: faUser,
    }),
  },
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
  children: [
    UsersGridRoute,
    UserRoute,
    AutoRoute,
    // BadgeRoute,
    AgentRoute,
    CostCenterRoute,
    CostCenterRationaleRoute,
    PiattaformaAttivitaLavorativaRoute,
    RepartoRoute,
  ],
  tile: true,
}
